import { DocumentSnapshot } from '@firebase/firestore-types'

export class PlanningEntry{
  public static of(s:DocumentSnapshot):PlanningEntry{
    return {
      id: s.id,
      data: s.data() as PlanningEntryData
    }
  }

  id: string
  data: PlanningEntryData
}

export class PlanningEntryData{
  dayOfWeek: number
  startTime: string
  stopTime: string
  title: string
  shortDesc: string
  coachId: string
  coachFirstName: string
  coachLastName: string
  placeId: string
  placeLongName: string
  placeShortName: string
  familly: Familly
  level: string
}

export enum Familly{
  SLD, GV
}

export enum Day{
  Lundi,Mardi,Mercredi,Jeudi,Vendredi
}

export class Place{
  public static of(s:DocumentSnapshot):Place{
    return {
      id: s.id,
      data: s.data() as PlaceData
    }
  }

  id:string
  data: PlaceData
}

export class PlaceData{
  shortName: string
  longName: string
}
